module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'number') ? _c('div', {
    staticClass: "c-home-footer-item u-relative u-fit-h u-force-3d",
    class: [_vm.activeIndex === _vm.index ? 'is-active' : '', 'c-home-footer-item--' + _vm.index, _vm.disabled ? 'is-disabled' : '', _vm.$root.isTouch ? 'is-touch' : ''],
    on: {
      "click": function($event) {
        _vm.changeActiveIndexTo(_vm.index)
      }
    }
  }, [_c('div', {
    staticClass: "c-home-footer-item__wrapper u-relative u-pos-center u-zindex--2 u-flex u-flex-fd--column",
    class: 'js-home-footer-item-wrapper--' + _vm.index
  }, [_c('div', {
    staticClass: "c-home-footer-item__wrapper__number-container u-uppercase t-ffamily--simplon t-fweight--bold t-fsize--xs u-align-center",
    class: 'js-home-footer-item-number--' + _vm.index
  }, [_c('span', [_vm._v(_vm._s(_vm.indexFormatted))])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-footer-item__wrapper__label-container u-uppercase t-ffamily--simplon t-fweight--bold t-fsize--xxs u-align-center u-hide@sm",
    class: 'js-home-footer-item-label--' + _vm.index
  }, _vm._l((_vm.labelArray), function(word, index) {
    return _c('span', {
      staticClass: "c-home-footer-item__wrapper__label-container__item u-relative u-inline-block u-valign-middle",
      class: ['c-home-footer-item__wrapper__label-container__item--' + (index + 1)]
    }, [_vm._v("\n                " + _vm._s(word) + "\n            ")])
  }))])]) : _c('div', {
    staticClass: "c-home-footer-item u-absolute u-flex u-flex-ai--center u-flex-jc--center u-fit-h u-cursor-pointer u-force-3d",
    class: ['c-home-footer-item--' + _vm.type, _vm.disabled ? 'is-disabled' : '', _vm.$root.isTouch ? 'is-touch' : ''],
    on: {
      "click": function($event) {
        _vm.type === 'next' ? _vm.onNextSlide() : _vm.onPrevSlide()
      }
    }
  }, [(!_vm.disabled) ? _c('div', {
    staticClass: "c-home-footer-item__wrapper u-relative u-zindex--2 u-fit u-force-3d"
  }, [_c('div', {
    staticClass: "c-home-footer-item__wrapper__line u-absolute u-hide@sm u-force-3d"
  }, [_c('app-icon', {
    staticClass: "c-home-footer-item__wrapper__line__arrow u-fill--white u-stroke--white",
    class: ['c-home-footer-item__wrapper__line__arrow--' + _vm.type],
    attrs: {
      "name": "icon-arrow-triangle--right.png"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-footer-item__wrapper__label-container u-absolute u-uppercase t-ffamily--simplon t-fweight--bold t-fsize--xxs u-force-3d"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])]) : _c('router-link', {
    staticClass: "c-home-footer-item__wrapper u-relative u-zindex--2 u-fit u-force-3d",
    attrs: {
      "to": _vm.$root.CONFIG.pages.token.path
    }
  }, [_c('div', {
    staticClass: "c-home-footer-item__wrapper__line u-absolute u-hide@sm u-force-3d"
  }, [_c('app-icon', {
    staticClass: "c-home-footer-item__wrapper__line__arrow u-fill--white u-stroke--white",
    class: ['c-home-footer-item__wrapper__line__arrow--' + _vm.type],
    attrs: {
      "name": "icon-arrow-triangle--right.png"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-footer-item__wrapper__label-container u-absolute u-uppercase t-ffamily--simplon t-fweight--bold t-fsize--xxs u-force-3d"
  }, [_vm._v("\n            Token\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390bdf30"}!./src/scripts/components/app-home-footer-item/template.html
// module id = 460
// module chunks = 0